import { manifest } from 'tdesign-icons-vue-next/esm/manifest';

interface IconManifestItem {
  stem: string;
  icon: string;
}

export interface TDesignIconOption {
  name: string;
}

const iconStemSet = new Set(manifest.map((item) => item.stem));
const stemByIconKey = new Map<string, string>();

function getIconKey(value: string) {
  return value
    .replace(/Icon$/, '')
    .replace(/[-_\s]/g, '')
    .toLowerCase();
}

const iconManifest = manifest as IconManifestItem[];

iconManifest.forEach((item) => {
  stemByIconKey.set(item.stem.toLowerCase(), item.stem);
  stemByIconKey.set(getIconKey(item.stem), item.stem);
  stemByIconKey.set(getIconKey(item.icon), item.stem);
});

export const tDesignIconList: TDesignIconOption[] = iconManifest.map((item) => ({
  name: item.stem,
}));

export function normalizeTDesignIconName(iconName?: string | null) {
  const value = iconName?.trim() || '';
  if (!value) return '';

  if (iconStemSet.has(value)) {
    return value;
  }

  return stemByIconKey.get(value.toLowerCase()) || stemByIconKey.get(getIconKey(value)) || value;
}
